import styled from 'styled-components';
import tw from 'twin.macro';

const OrgSettingsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 20px;
`;

export { OrgSettingsContainer };
